var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"from-boti":false,"title":("התזרים של " + _vm.monthName + " מוכן "),"text":'אפשר לעבור על התזרים ולערוך אותו עם העפרון ✏️',"notification-buttons":[
                  {
                    size:'normal',
                    title:'להסבר על התזרים',
                    subTitle: 'איך בנינו אותו?',
                    variant: 'primary',
                    action: _vm.openTour,
                  },
                  {
                    size:'normal',
                    title:'לתזרים',
                    variant: 'secondary',
                    action: _vm.skipTour,
                  } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }